import { nextTick, onMounted, ref } from 'vue';

const KEY = 'bb-scroll-top';

export function useBackButton(onClose: () => void) {
  const isTransitionDisabled = ref(false);
  let _isClose = false;
  onMounted(() => {
    function onPopState() {
      if (_isClose) {
        // if the user closes the dialog via the close function, we call the onClose function directly
        onClose();
        _isClose = false;
      } else {
        // if the user presses the back button, we disable the transition before closing the dialog
        nextTick(onClose);
        isTransitionDisabled.value = true;
        setTimeout(() => (isTransitionDisabled.value = false), 300);
      }
    }
    history.pushState({ [KEY]: document.documentElement.scrollTop }, '', location.href);
    window.addEventListener('popstate', onPopState, { once: true });
  });

  function close() {
    _isClose = true;
    history.back();
  }

  return { close, isTransitionDisabled };
}

if (!import.meta.env.SSR) {
  // This is just needed so when the user presses the forward button, the scroll position is restored.
  // It's a bit hacky, but it works. At least on desktop, iOS Safari has some weird timing.
  window.addEventListener('popstate', (e) => {
    // restore scroll position if it was saved
    const scrollTop = e.state?.[KEY];
    if (scrollTop) setTimeout(() => window.scrollTo(0, scrollTop));
  });
}
